import { Button, Grid } from "@material-ui/core";
import DataListHeader from "components/DataListHeader";
import DataTable from "components/DataTable/DataTable";
import LoadingSpinner from "components/LoadingSpinner";
import PageComponent from "components/Page/PageComponent";
import useSortOptions from "hooks/useSortOptions";
import { IconEdit } from "icons";
import { orderBy } from "lodash";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import FilterService from "services/filterService";
import { arrayToObject } from "utils/object-util";
import EditCarrierDialog from "./EditCarrierDialog";
import { setSearchVal } from "./carrierFiltersSlice";
import { useGetAllCarriersQuery } from "./carrierSlice";
import Authorize from "components/Authorize";
import { permissionProfiles } from "components/Authorize/permissionProfiles";

const CarriersPage = ({ }) => {

    const dispatch = useDispatch();
    const { searchVal } = useSelector(state => state.carrierFilters);
    const [sortOptions, sortData] = useSortOptions();
    const [carrierToEdit, setCarrierToEdit] = useState();
    const [openDialog, setOpenDialog] = useState(false);

    let { data: carriers, error: carriersError, isLoading: isLoadingCarriers } = useGetAllCarriersQuery();
    carriers = carriers || [];

    const getAddress = (row, index) => {
        let address;

        if (index == 0) {
            address = [row?.address, row?.city, row?.state, row?.zipcode]?.filter(Boolean)?.join(', ');
        } else {
            address = [row?.secAddress, row?.secCity, row?.secState, row?.secZipcode]?.filter(Boolean)?.join(', ');
        }
        return address;
    }

    const columns = [
        { name: "Name", key: "name" },
        { name: "SCAC", key: 'scac' },
        { name: "POC Name", key: 'pocName' },
        { name: "POC Phone", key: 'pocPhone' },
        { name: "POC Email", key: 'pocEmail' },
        { name: "POC Address", component: (row) => getAddress(row, 0), width: 200 },
        { name: "Secondary POC Name", key: 'secPocName' },
        { name: "Secondary POC Phone", key: 'secPocPhone' },
        { name: "Secondary POC Email", key: 'secPocEmail' },
        { name: "Secondary POC Address", component: (row) => getAddress(row, 1) },
    ]

    const carrierLookup = arrayToObject(carriers);

    const rowActions = (rowId) => {
        const row = carrierLookup[rowId];
        return [
            {
                icon: <IconEdit />,
                onClick: () => { setCarrierToEdit(row); setOpenDialog(true); },
                profile: permissionProfiles.CARRIERS.EDIT
            }
        ];
    }

    const onSearch = (val) => {
        dispatch(setSearchVal(val));
    };

    const mapExportData = row => {
        const carriers = {};
        columns?.map(col => {
            if (col.name) {
                carriers[col.name] = row?.[col.key]
            }
        });
        carriers['POC Address'] = getAddress(row, 0);
        carriers['Secondary POC Address'] = getAddress(row, 1);
        return carriers;
    }

    let filteredCarriers = FilterService.filter([], searchVal, carriers);

    return (
        <PageComponent
            header={<DataListHeader
                title={'Carriers'}
                data={filteredCarriers}
                onSearch={onSearch}
                actionButtons={
                    <Authorize profile={permissionProfiles.CARRIERS.EDIT}>
                        <Grid container direction='row' spacing={1}>
                            <Grid item>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    onClick={() => { setCarrierToEdit({}); setOpenDialog(true) }}
                                >
                                    Create Carrier
                                </Button>
                            </Grid >
                        </Grid>
                    </Authorize>
                }
            />}
        >
            {isLoadingCarriers ? <LoadingSpinner loading={isLoadingCarriers} /> :
                <DataTable
                    mapExportData={mapExportData}
                    noItemsMessage={isLoadingCarriers ? 'Loading...' : 'No carriers found'}
                    allowColumnCustomization={true}
                    columns={columns}
                    rows={orderBy(
                        filteredCarriers,
                        sortOptions.columnToSort,
                        sortOptions.sortDirection
                    )}
                    rowIdentifier='id'
                    onSort={sortData}
                    sortDirection={sortOptions.sortDirection}
                    columnToSort={sortOptions.columnToSort}
                    title={'Carriers'}
                    actions={rowActions}

                />}
            {!!carrierToEdit && <EditCarrierDialog
                open={openDialog}
                onClose={() => { setCarrierToEdit(); setOpenDialog(false) }}
                carrier={carrierToEdit}
                setCarrier={setCarrierToEdit}
            />}
        </PageComponent>
    )
};

export default CarriersPage;